var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpotify = function SvgSpotify(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#spotify_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.465 14.184c-5.158-3.063-13.665-3.344-18.589-1.85a1.496 1.496 0 1 1-.869-2.864c5.652-1.715 15.048-1.384 20.985 2.14a1.496 1.496 0 0 1-1.528 2.574m-.168 4.537a1.248 1.248 0 0 1-1.716.41c-4.3-2.642-10.857-3.408-15.944-1.864a1.25 1.25 0 0 1-1.556-.831 1.249 1.249 0 0 1 .831-1.556c5.811-1.763 13.036-.91 17.974 2.126.586.36.771 1.129.41 1.715Zm-1.958 4.357a.997.997 0 0 1-1.372.331c-3.757-2.296-8.486-2.814-14.055-1.542a.996.996 0 1 1-.444-1.944c6.095-1.393 11.323-.794 15.54 1.783a.997.997 0 0 1 .33 1.372M16 0C7.164 0 0 7.163 0 16s7.164 16 16 16c8.837 0 16-7.163 16-16S24.837 0 16 0",
    fill: "#1ED760"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "spotify_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgSpotify;